import { AxiosRequestConfig } from "axios";

export interface Credentials extends AxiosRequestConfig {
  email: string;
  password: string;
}

export class IFrameCredentials {
  constructor(
    public user_id: null | string = null,
    public user_zuid: null | string = null,
    public user_email: null | string = null,
    public domain: null | string = null,
    public organization_id: null | string = null
  ) {}

  public isFulfilled(): boolean {
    return (
      this.user_id !== null &&
      this.user_zuid !== null &&
      this.user_email !== null &&
      this.domain !== null &&
      this.organization_id !== null
    );
  }
}
